import { render, staticRenderFns } from "./EducationalGroupStorageSpaceComponent.vue?vue&type=template&id=43cf0fb7&"
import script from "./EducationalGroupStorageSpaceComponent.vue?vue&type=script&lang=js&"
export * from "./EducationalGroupStorageSpaceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports